import {
  GET_ORDER_PART_STEP_COMPANY_LIST_REQUEST,
  GET_ORDER_PART_STEP_COMPANY_LIST_SUCCESS,
  GET_ORDER_PART_STEP_COMPANY_LIST_FAIL,
  GET_SINGLE_ORDER_PART_STEP_COMPANY_REQUEST,
  GET_SINGLE_ORDER_PART_STEP_COMPANY_SUCCESS,
  GET_SINGLE_ORDER_PART_STEP_COMPANY_FAIL,
  DELETE_ORDER_PART_STEP_COMPANY_REQUEST,
  DELETE_ORDER_PART_STEP_COMPANY_SUCCESS,
  DELETE_ORDER_PART_STEP_COMPANY_FAIL,
  ADD_ORDER_PART_STEP_COMPANY_REQUEST,
  ADD_ORDER_PART_STEP_COMPANY_SUCCESS,
  ADD_ORDER_PART_STEP_COMPANY_FAIL,
  UPDATE_ORDER_PART_STEP_COMPANY_REQUEST,
  UPDATE_ORDER_PART_STEP_COMPANY_SUCCESS,
  UPDATE_ORDER_PART_STEP_COMPANY_FAIL,
} from "src/constants/types";

export const orderPartStepCompanyReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_ORDER_PART_STEP_COMPANY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_ORDER_PART_STEP_COMPANY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        orderPartStepCompanyList: actions.payload,
        error: "",
      };
    case GET_ORDER_PART_STEP_COMPANY_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_ORDER_PART_STEP_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_ORDER_PART_STEP_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        orderPartStepCompany: actions.payload,
      };
    case GET_SINGLE_ORDER_PART_STEP_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_ORDER_PART_STEP_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_ORDER_PART_STEP_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_ORDER_PART_STEP_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_ORDER_PART_STEP_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_ORDER_PART_STEP_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_ORDER_PART_STEP_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_ORDER_PART_STEP_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_ORDER_PART_STEP_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_ORDER_PART_STEP_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
